import type { TFrame } from '@lucimark/shared/models/playlist'
import { AssetType } from '@lucimark/shared/models/asset-type'

/**
 * True when any layout section facet is a video (MP4 or HLS gallery assets use {@link AssetType.Video}).
 * Embedded playlist / RSS directory frames are not treated as video here (vestigial or non-facet content).
 */
export function frameHasVideoFacet(frame: TFrame): boolean {
  if (frame.playlistRef != null || frame.rssDirectoryRef != null) {
    return false
  }
  const facets = frame.facets
  if (facets == null) {
    return false
  }
  for (const facet of Object.values(facets)) {
    if (facet?.type === AssetType.Video) {
      return true
    }
  }
  return false
}
